import { b2x } from '@b2x/react/src';
import classnames from 'classnames';
import React from 'react';

import { useAppStaticContext } from '../AppContext';

export interface PageProps extends b2x.PageProps {
  headerCheckout?: boolean;
  hideFooter?: boolean;
  hideHeader?: boolean;
}

export const Page = ({
  children,
  className,
  headerCheckout = false,
  hideFooter = false,
  hideHeader = false,
  ...otherProps
}: PageProps) => {
  const { pageReady } = b2x.useAppContext();
  const { setHeaderCheckout, setHideFooter, setHideHeader } = useAppStaticContext();

  React.useEffect(() => {
    pageReady && setHeaderCheckout(headerCheckout);
    pageReady && setHideHeader(hideHeader);
    pageReady && setHideFooter(hideFooter);
  }, [pageReady, headerCheckout, setHeaderCheckout, hideFooter, hideHeader, setHideFooter, setHideHeader]);

  return (
    <b2x.Page {...otherProps} className={classnames(className, 'h-100')}>
      <div className={classnames('page h-100 position-relative')}>
        <div className={classnames('position-relative h-100')}>{children}</div>
      </div>
    </b2x.Page>
  );
};
